import type {Token} from '@sail/engine';
import {assignTokens, toIntent} from '@sail/engine';
import {tokens} from '@sail/tokens/deprecated';
import {DrawerConfig} from '../components/drawer/DrawerConfig';
import {DialogConfig} from '../components/dialog/DialogConfig';
import {TooltipConfig} from '../components/Tooltip';
import {BackdropConfig} from '../components/Backdrop';
import {PopoverConfig} from '../components/popover';
import {CounterConfig} from '../components/Counter';

// [TODO]: once we control dark mode through CSS these overrides should
// be moved into the actual component CSS instead of being customize calls
// we should also remove the elevation overrides here
export const lightModeComponentOverrides = toIntent([
  DialogConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  DrawerConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  TooltipConfig.customize({}),
  BackdropConfig.customize({}),
  PopoverConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  CounterConfig.customize({}),
]);

export const lightModeTokenOverrides = (): Token.OverrideIntent =>
  assignTokens(tokens, {});
